import React, { useEffect, useState } from "react";
import classes from "./ChatPage.module.css";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    ChatApi,
    FetchBlogsApi,
    FetchCartoonsApi,
    FetchGamesApi,
    FetchYogaVideosApi,
    GetLatestNewsApi,
    RandomQuestionsApi,
    scrapGoogleDataApi,
    UserChatHistoryApi,
} from "../../Api/api";
import { useNavigate } from "react-router-dom";
import Layout from "../../Components/Layout";
import Navbar from "../../Components/Navbar";
import { motion } from "framer-motion";
import SmallLoader from "../../Components/Loaders/SmallLoader";
import { setData } from "../../slices/dataSlice";
import CategoryTitle from "../../Components/Category-Section/CategoryTitle";
import CategoryDragSection from "../../Components/Category-Section/CategoryDragSection";
import Button from "../../Components/Button";
import CategoryNews from "../../Components/Category-Section/CategoryNews";
import ChatBox from "../../Components/Chat-Box/ChatBox";
import ChatInputBox from "../../Components/Chat-Box/ChatInputBox";
import moment from "moment-timezone";
import ChatVoiceModal from "../../Components/Chat-Box/ChatVoiceModal";
import CategoryBlogs from "../../Components/Category-Section/CategoryBlogs";
import UserLocation from "../../Components/UserLocation";

const ChatPage = () => {
    const { expand } = useSelector((state) => state?.sidebarSlice);
    const { user } = useSelector((state) => state?.userSlice);
    const { data } = useSelector((state) => state?.dataSlice);
    const dispatch = useDispatch();
    const [messages, setMessages] = useState([]);
    const [chatHistory, setChatHistory] = useState([]);

    const [locationPermission, setLocationPermission] = useState(false);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");

    const navigate = useNavigate();

    const [message, setMessage] = useState("");

    const [chatHistoryLoading, setChatHistoryLoading] = useState(true);
    const [aiChatLoading, setAiChatLoading] = useState(false);

    const [questions, setQuestions] = useState([]);

    const [questionsLoading, setQuestionsLoading] = useState(true);

    const [newsActive, setNewsActive] = useState({});

    const [chatVoiceModal, setChatVoiceModal] = useState(false);

    // const [blogLoading, setBlogLoading] = useState(true);
    // const [blogs, setBlogs] = useState([]);

    const handleMessageSubmit = async (e, query) => {
        e.preventDefault();
        setAiChatLoading(true);
        if (query) {
            setMessages([
                {
                    request: JSON.stringify(query),
                    response: JSON.stringify(""),
                    user_id: user?.id,
                    msisdn: user?.msisdn,
                },
            ]);
        } else {
            setMessages([
                {
                    request: JSON.stringify(message),
                    response: JSON.stringify(""),
                    user_id: user?.id,
                    msisdn: user?.msisdn,
                },
            ]);
        }

        setMessage("");
        try {
            const response = await ChatApi(
                {
                    user_id: user?.id,
                    msisdn: user?.msisdn,
                    chat_id: null,
                    message: query ? query : message,
                    latitude: latitude,
                    longitude: longitude,
                    locationPermission: locationPermission,
                },
                user?.token
            );
            let newMsgArray = [response?.data?.result];

            setMessages(newMsgArray);
            setAiChatLoading(false);
            navigate(`/app/${response?.data?.result?.chat_id}`);
        } catch (error) {
            setAiChatLoading(false);
            toast.error(
                error?.response?.data?.err ||
                error?.data?.err ||
                error?.message ||
                error
            );
        }
    };

    useEffect(() => {
        fetchChatHistory();
    }, []);

    useEffect(() => {
        if (!data) {
            fetchRandomQuestions();
        } else {
            setQuestionsLoading(false);
        }
    }, [data]);

    const fetchChatHistory = async () => {
        try {
            setChatHistoryLoading(true);
            const response = await UserChatHistoryApi(
                { msisdn: user?.msisdn },
                user?.token
            );
            setChatHistory(response?.data?.result);
            setChatHistoryLoading(false);
        } catch (error) {
            setChatHistoryLoading(false);
            toast.error(
                error?.response?.data?.err ||
                error?.data?.err ||
                error?.message ||
                error
            );
        }
    };

    const fetchRandomQuestions = async () => {
        try {
            setQuestionsLoading(true);
            const response = await RandomQuestionsApi();
            setQuestionsLoading(false);
            dispatch(setData({ questions: response?.data?.result }));
            // setQuestions(response?.data?.result);
        } catch (error) {
            setQuestionsLoading(false);
            toast.error(
                error?.response?.data?.err ||
                error?.data?.err ||
                error?.message ||
                error
            );
        }
    };

    const onClickQuestionHandler = (e, question) => {
        setMessage(question);
        setTimeout(() => {
            handleMessageSubmit(e, question);
        }, 200);
    };

    console.log(data, 'd');

    return (
        <UserLocation
            setLatitude={setLatitude}
            setLongitude={setLongitude}
            setLocationPermission={setLocationPermission}
        >
            <Layout
                expand={expand}
                chatHistoryLoading={chatHistoryLoading}
                chatHistory={chatHistory}
                chat_id={null}
            >
                <Navbar
                    chatHistoryLoading={chatHistoryLoading}
                    chatHistory={chatHistory}
                    chat_id={null}
                />

                <div className={classes.chat_container}>
                    {messages.length <= 0 ? (
                        <div className={classes.chat_input_output_container}>
                            <div className={classes.main_intro_section}>
                                <motion.div className={classes.section_categories}>
                                    {/* <CategoryTitle title="Try Me" /> */}
                                    {/* <div className={classes.heading_container}>
                                        <img src="/assets/images/ai-logo2.png" alt="AI" className={classes.logo} />
                                        <p className={classes.heading}>Your Clara AI Assistant</p>
                                    </div> */}

                                    <div className={classes.intro_section}>
                                        <p className={classes.intro}>Hello, Friend!</p>
                                        <p className={classes.intro_2}>How can I help you today?</p>
                                    </div>


                                    {questionsLoading ? (
                                        <div className={classes.loader_container}>
                                            <SmallLoader />
                                        </div>
                                    ) : (
                                        <CategoryDragSection
                                            data={data?.questions ? data?.questions : questions}
                                            dataItemKeys={{ imgurl: "", name: "" }}
                                            category="questions"
                                            onClickHandler={onClickQuestionHandler}
                                            slice={true}
                                        />
                                    )}
                                </motion.div>
                            </div>
                        </div>
                    ) : (
                        <ChatBox
                            aiChatLoading={aiChatLoading}
                            chatLoading={false}
                            messages={messages}
                        />
                    )}

                    <ChatInputBox
                        message={message}
                        handleMessageSubmit={handleMessageSubmit}
                        setMessage={setMessage}
                        setChatVoiceModal={setChatVoiceModal}
                    />

                    <ChatVoiceModal
                        setChatVoiceModal={setChatVoiceModal}
                        chatVoiceModal={chatVoiceModal}
                        handleMessageSubmit={handleMessageSubmit}
                    />
                </div>
            </Layout>
        </UserLocation>
    );
};

export default ChatPage;
